import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BsEye, BsEyeSlash } from "react-icons/bs";
import { RiLogoutCircleRLine } from "react-icons/ri";
import toast from 'react-hot-toast';
import logomobi from '../../assets/images/mobicom.png'
import CustomisedModal from '../../components/Modal/CustomisedModal';


const MyProfile = () => {

    const navigate = useNavigate()

    const user = JSON.parse(localStorage.getItem('user'));


    const [modal, setModal] = useState(false);
    const [store, setStore] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState({
        oldPassword: false,
        newPassword: false
    });

    const togglePasswordVisibility = (fieldName) => {
        setShowPassword(prev => ({ ...prev, [fieldName]: !prev[fieldName] }));
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const editStore = () => {
        navigate('/edit-vendors/' + store.id)
    }

    const logoutUser = () => {
        setModal(!modal);
    }

    const logoutStore = () => {
        localStorage.removeItem('user');
        // localStorage.removeItem('permissions');
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        toast.success("Log out successfully")
        navigate("/login");
    }








    return (
        <>
            <div>
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                            <h4 className="mb-sm-0">My Profile</h4>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-12'>

                        <div className='account_user'>
                            <div className='img_wrapper'>
                                <img src={logomobi} className='logo_img img-fluid' alt='Logo' />
                            </div>
                            <div className='contents'>
                                {/* <h5>Mobicom</h5> */}
                                <p>{user?.username}</p>
                            </div>
                        </div>




                        {/* <div className='store_bank_details'>
                            <div className='store_details'>
                                <h5>Change Password</h5>
                            </div>
                            <Form className='change_pass_form_wrapper'>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <Form.Label>Old Password</Form.Label>
                                            <div className='eye_icon_wrapper'>
                                                <Form.Control
                                                    type={showPassword.oldPassword ? 'text' : 'password'}
                                                    placeholder=""

                                                />
                                                {showPassword.oldPassword ? (
                                                    <BsEye className='eye_icon' onClick={() => togglePasswordVisibility("oldPassword")} />
                                                ) : (
                                                    <BsEyeSlash className='eye_icon' onClick={() => togglePasswordVisibility("oldPassword")} />
                                                )}
                                            </div>
                                        </Form.Group>
                                    </div>
                                    <div className='col-lg-6'>
                                        <Form.Group className="mb-3" controlId="formBasicPassword">
                                            <Form.Label>New Password</Form.Label>
                                            <div className='eye_icon_wrapper'>
                                                <Form.Control
                                                    type={showPassword.newPassword ? 'text' : 'password'}
                                                    placeholder=""

                                                />
                                                {showPassword.newPassword ? (
                                                    <BsEye className='eye_icon' onClick={() => togglePasswordVisibility("newPassword")} />
                                                ) : (
                                                    <BsEyeSlash className='eye_icon' onClick={() => togglePasswordVisibility("newPassword")} />
                                                )}
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>

                                <Button className='login_btn' type="submit">
                                    {loading ? "Loading" : "Update"}
                                </Button>
                            </Form>
                        </div> */}

                        <div className='btn_wrapper_logout'>
                            <Button className='update_btn' onClick={() => logoutUser()}><RiLogoutCircleRLine className='icon' /> Log Out</Button>
                        </div>
                        <CustomisedModal
                            isOpen={modal}
                            customClass={"policy_modal"}
                            toggle={toggleModal}
                        >
                            <h5>
                                Are you sure you want to log out?
                            </h5>
                            <div className="policy_Agree">
                                <Button
                                    onClick={() => {
                                        setModal(!modal);
                                    }}
                                    size="lg"
                                    className='btn_cancel'
                                >
                                    Cancel
                                </Button>
                                <Button
                                    size="lg"
                                    className='btn'
                                    onClick={() => logoutStore()}
                                >
                                    Log Out
                                </Button>
                            </div>
                        </CustomisedModal>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MyProfile